<template lang="pug">
aside.cart-vue
  header.header

  table.itemdata
    tbody
      tr
        th(scope="row")
          span.label Mouser Part #: 
        td
          span.title
            div(id="divMouserItem")
      tr
        th(scope="row") 
          span.label SV Part #: 
        td 
          span.title {{ configID }}
      tr
        th(scope="row") 
          span.label Lead Time: 
        td 
          span.title
            div(id="divLeadTime")
      tr
        th(scope="row") 
          span.label Min Quantity: 
        td 
          span.title
            div(id="divMinQty")

  table.pricing 
    thead
      tr
        th(scope="col", width="80%") Quantity
        th(scope="col") Price
    tbody
      tr
        th(scope="row") 1-9
        td 
          div(id="divPrice1")
      tr
        th(scope="row") 10-25
        td 
          div(id="divPrice2")

  form.add
    label.label(for="qty") 
    .control
      input#qty(
        v-model="quantity",
        type="text",
        inputmode="numeric",
        min="0",
        step="1",
        pattern="[0-9]+"
      )
      .ticker
        button(type="button", @click.stop.prevent="change(1)") +
        button(type="button", @click.stop.prevent="change(-1)") &ndash;
      button(type="button", @click.stop.prevent="add()") Add to Mouser cart test

  .action
    button(type="button", @click.stop.prevent="print")
      i.glyph-print
      span Print Datasheet

</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Cart",
  props: ["configID", "title", "price", "emailBody", "emailTopic"],
  data() {
    return {
      quantity: 1,
    };
  },
  computed: {
    ...mapGetters(["cart"]),
  },
  methods: {
    change(delta) {
      if (delta < 0 && this.quantity < 1) return;
      this.quantity = this.quantity + delta;
    },
    async add() {
      let svmProductSku = this.$route.params.product;
      const mouserCartURL = "https://www.mouser.com/cart/CartLandingPage.aspx?guid=";
      let mouserItemNumber = await this.getMouserProduct(svmProductSku);

      fetch(`/api/CableBuilder/MouserCartInsert/${mouserItemNumber}?qty=${this.quantity}`, {
        method: 'POST',
            }
          )
        .then(response => response.json())
        .then(data => {
          let cartKey = data.CartKey;
          window.open(mouserCartURL+cartKey, '_blank');
        }).catch(function (error) {
          alert(error);
        });
    },

    async getMouserProduct(svmProductSku) {
      const mouserApi = "https://api.mouser.com/api/v2";
      const searchApiKey = "fcd9db7e-189a-4a33-a7fd-58aca4815e2d";
      let result = "";

      await fetch(`${mouserApi}/search/partnumberandmanufacturer?apiKey=${searchApiKey}`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
              "SearchByPartMfrNameRequest": { 
                "manufacturerName": "Amphenol",
                //"mouserPartNumber": "FRSMPM-085-FRSMPM-080",
                "mouserPartNumber": String(svmProductSku + "-" + String((this.$route.query.length*10)).padStart(3,'0')),
                "partSearchOptions": ""
              }
            })
          }
        )
        .then(response => response.json())
        .then(data => {
          result = data.SearchResults.Parts[0].MouserPartNumber;
        })
        .catch(function (error) {
          result =  "X";
          console.log(error)
        });
      return result;
    },

    async getMouserPriceBreaks() {
      let svmProductSku = this.$route.params.product;
      const mouserApi = "https://api.mouser.com/api/v2";
      const searchApiKey = "fcd9db7e-189a-4a33-a7fd-58aca4815e2d";
      let mouserItem;
      let leadTime;
      let minQty;
      let price1;
      let price2;

      await fetch(`${mouserApi}/search/partnumberandmanufacturer?apiKey=${searchApiKey}`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
              "SearchByPartMfrNameRequest": { 
                "manufacturerName": "Amphenol",
                "mouserPartNumber": String(svmProductSku + "-" + String((this.$route.query.length*10)).padStart(3,'0')),
                "partSearchOptions": ""
              }
            })
          }
        )
        .then(response => response.json())
        .then(data => {
          mouserItem = data.SearchResults.Parts[0].MouserPartNumber;
          leadTime = data.SearchResults.Parts[0].LeadTime;
          minQty = data.SearchResults.Parts[0].Min;
          price1 = data.SearchResults.Parts[0].PriceBreaks[0].Price;
          price2 = data.SearchResults.Parts[0].PriceBreaks[1].Price;
        })
        .catch(function (error) {
          result =  "0";
          console.log(error)
        });
      document.getElementById("divMouserItem").innerHTML = mouserItem;
      document.getElementById("divLeadTime").innerHTML = leadTime;
      document.getElementById("divMinQty").innerHTML = minQty;
      document.getElementById("divPrice1").innerHTML = price1;
      document.getElementById("divPrice2").innerHTML = price2;
    },
    preparePrint() {
      //document.documentElement.classList.add("printingProductSheet");
      var a = document.body;
      a.classList ? a.classList.add('printView') : a.className += ' printView';
    },
    print() {
      window.print();
    },
    destroyPrint() {
      //document.documentElement.classList.remove("printingProductSheet");
      var a = document.body, c = ' printView';
      $(a).removeClass(c);
    },
  },
  watch: {
    quantity() {
      let { quantity } = this;
      if (!quantity) return (this.quantity = 0);
      quantity = parseInt(quantity);
      if (this.quantity !== quantity) this.quantity = quantity;
    },
  },
  created() {
    window.addEventListener("beforeprint", this.preparePrint);
    window.addEventListener("afterprint", this.destroyPrint);
  },
  mounted(){
    this.getMouserPriceBreaks();
  },
  beforeDestroy() {
    window.removeEventListener("beforeprint", this.preparePrint);
    window.removeEventListener("afterprint", this.destroyPrint);
  },
};
</script>

<style lang="scss">
//print styles

@media print {
  @page {
    size: landscape;
    margin: 0mm;
  }

  .header {
    display: none !important;
    height: 0 !important;
  }

  .printView
  {
    body,
    #page {
      background: none !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    
    .main-header,
    .configuration-title,
    .section,
    .bill-of-materials,
    .rail,
    .part-number-search,
    .footer {
      display: none !important;
      height: 0;
    }

    .drawing {
      max-width: 80%;
    }

    //reset the things we want visible
    .configuration .sheet {
      background: $white  !important;
    }

    .configuration .sheet,
    .configuration .sheet * {
      visibility: visible !important;
    }

    .drawing {
      padding-top: 0;
      padding-bottom: 0;
    }

    .main {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
.cart-vue {
  display: flex;
  flex-direction: column;

  table {
    width: auto;
  }
}

.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 0.5rem;
  //border-bottom: 1px solid $lightGray;
  margin: 0 0 0.5rem;

  .label {
    font-size: 1rem;
    text-transform: uppercase;
    font-weight: 700;
    line-height: 1;
    margin: 0 0 0.5rem;
  }

  .title {
    font-size: 1rem;
    text-transform: uppercase;
    margin: 0;
  }

  
}
.itemdata {
    border-collapse: collapse;
    margin: 0 1rem 1.5rem;
    padding: 0;
    font-size: 1rem;
    text-align: left;

    .label {
      font-size: 1rem;
      text-transform: uppercase;
      font-weight: 700;
      line-height: 1;
      margin: 0 0 0.5rem;
    }

    .title {
      font-size: 1rem;
      text-transform: uppercase;
      margin: 0;
    }

    tbody {
      tr {
        border-bottom: 1px solid $lightGray;

        th,
        td {
          font-weight: 400;
          padding: 0.75rem 0;
        }

        td {
          white-space: nowrap;
        }
      }
    }
  }

.pricing {
  border-collapse: collapse;
  margin: 0 1rem 1.5rem;
  padding: 0;
  font-size: 1rem;
  text-align: left;

  tbody {
    tr {
      border-bottom: 1px solid $lightGray;

      th,
      td {
        font-weight: 400;
        padding: 0.75rem 0;
      }

      td {
        white-space: nowrap;
      }
    }
  }
}

.add {
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  margin: 0 0 2rem;

  label {
    font-size: 0.875rem;
    font-weight: 700;
    margin: 0 0 1rem;
    line-height: 0;
  }

  .control {
    display: flex;
    gap: 0.3875rem;
    flex: 0 0 auto;
    box-sizing: border-box;
  }

  input {
    appearance: none;
    border: 2px solid $lightGray;
    border-radius: 0;
    background: 0;
    padding: 1rem;
    font-size: 1rem;
    line-height: 1;
    flex: 1 3 100%;
    width: auto;
    height: auto;
    min-width: 0;
    text-align: center;
    margin: 0;
  }

  .ticker {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    gap: 0.25rem;

    button {
      color: $black;
      background: $lightGray;
      flex: 1 0 0;
      padding: 0 0.5rem;
      line-height: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }

  button {
    cursor: pointer;
    appearance: none;
    //background: $red;
    background: #0070BB;
    border: none;
    border-radius: 0;
    padding: 1rem;
    font-size: 0.875rem;
    line-height: 1;
    flex: 1 2 100%;
    color: $white;
    white-space: nowrap;
    text-transform: uppercase;
  }
}

.action {
  display: flex;
  justify-content: center;
  padding: 1.5rem;
  margin: 0;
  border-top: 1px solid $lightGray;
  border-bottom: 1px solid $lightGray;
  //gap: 1rem;

  button {
    display: flex;
    appearance: none;
    background: transparent;
    color: $black;
    border: none;
    outline: none;
    //gap: 0.5rem;
    padding: 0;
    cursor: pointer;
    transition: 0.125s ease;
    margin-bottom: 1rem;

    &:hover {
      color: $red;
      background: transparent;
    }

    i {
      margin-right: 0.5rem;
    }

    span {
      text-transform: uppercase;
      font-weight: 700;
      font-size: 0.8rem;
    }
  }
}

.notes {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  font-size: 0.8rem;


  .label {
    font-weight: 700;
    line-height: 1;
    margin: 0 0 0.25rem;
    text-transform: uppercase;
  }

  div {
    &::v-deep {
      &>*:last-child {
        margin-top: 0;
      }

      *:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.notes a {
  color: #004E7D;
}
</style>